import { type CorrespondenceLanguage } from "../generated-types";

export const getPowerOfAttorneyTermsAndConditions = (
  pdfLanguage: CorrespondenceLanguage,
): string => {
  return `/commercial/api/power-of-attorney/terms-and-condition?pdfLanguage=${pdfLanguage}`;
};
